import { render } from "./SemesterListPage.vue?vue&type=template&id=0db7642d"
import script from "./SemesterListPage.vue?vue&type=script&lang=js"
export * from "./SemesterListPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__